"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OauthScope = void 0;
exports.OauthScope = {
    AuthorizedUserRead: "authorized_user:read",
    AssetsRead: "assets:read",
    AssetsWrite: "assets:write",
    CmsRead: "cms:read",
    CmsWrite: "cms:write",
    CustomCodeRead: "custom_code:read",
    CustomCodeWrite: "custom_code:write",
    EcommerceRead: "ecommerce:read",
    EcommerceWrite: "ecommerce:write",
    FormsRead: "forms:read",
    FormsWrite: "forms:write",
    PagesRead: "pages:read",
    PagesWrite: "pages:write",
    SitesRead: "sites:read",
    SitesWrite: "sites:write",
    UsersRead: "users:read",
    SiteActivityRead: "site_activity:read",
    UsersWrite: "users:write",
    WorkspaceRead: "workspace:read",
    WorkspaceWrite: "workspace:write",
    SiteConfigRead: "site_config:read",
    SiteConfigWrite: "site_config:write",
};
